import Add from '@mui/icons-material/Add'
import Delete from '@mui/icons-material/Delete'
import Edit from '@mui/icons-material/Edit'
import { Box, Dialog, IconButton, Popover } from '@mui/material'
import { useEffect, useState } from 'react'
import ConfirmationModal, {
  CustomSelect,
  selectTypes,
} from 'src/consumer/components/helperComponents'
import { FEATURE_BUNDLE_TYPES_ARRAY } from 'src/consumer/constants'
import {
  defaultConfirmationModalProps,
  genericHandleChange,
} from 'src/consumer/helpers/utilFunctions'
import { GenericModalHeadlineLevelTwo } from 'src/mentor/components/MentorAvailabilityPage/MentorAvailabilityPageStyles'
import {
  ChangesWillNotBeSavedButton,
  MentorEventsPageStyledDialogPaper,
} from '../../MentorEventsPageStyles'
import BaseAddCustomPriceComponent from '../BaseAddCustomPriceComponent'
import {
  ActualBundlePacksContainer,
  BundlePackHeadingContainer,
  BundlePackItem,
} from './styledComponents'

export default function SelectABundle({
  selectedPlanId,
  selectedBundleIds,
  setSelectedBundleIds,
  refreshBundles,
  allBundles,
  allOneOnOnes,
  mentorProfileData,
  isDisabled,
}) {
  const [showAddCustomPrice, setShowAddCustomPrice] = useState(false)
  const [bundlePackToEdit, setBundlePackToEdit] = useState()
  const [popoverAnchor, setPopoverAnchor] = useState(null)
  const [reactSelectedBundle, setReactSelectedBundle] = useState()
  const [confirmationProps, setConfirmationProps] = useState(defaultConfirmationModalProps)

  function addBundle(event) {
    setPopoverAnchor(event.currentTarget)
  }

  function addBundleToList(bundle) {
    if (reactSelectedBundle?.id) {
      setSelectedBundleIds((prev) => [reactSelectedBundle?.id, ...prev])
    }
    closeAddBundlePopover()
  }

  function createBundle() {
    setShowAddCustomPrice(true)
    setBundlePackToEdit({
      title: '',
      packKind: 'session',
      eligibleSubscriptionPlanId: selectedPlanId || '',
      sessionCount: 5,
      expiryInDays: 30,
      bundle: [{ type: FEATURE_BUNDLE_TYPES_ARRAY?.[0]?.id, maxCount: 1 }],
    })
  }

  function deleteBundle(idx) {
    setConfirmationProps((prev) => ({
      ...prev,
      action: 'delete',
      visibility: 'true',
      visibilitySetter: setConfirmationProps,
      body: 'Are you sure you want to delete this bundle?',
      buttonColor: 'error',
      onSubmitFunctions: [
        () => {
          setSelectedBundleIds((prev) => {
            const newBundleIds = [...prev]
            newBundleIds.splice(idx, 1)
            return newBundleIds
          })
        },
      ],
    }))
  }

  function editBundle(idx) {
    // show the bundle pack modal
    const foundBundleId = selectedBundleIds?.[idx]
    const foundBundle = allBundles?.find((bundle) => bundle?.id === foundBundleId)
    setBundlePackToEdit(foundBundle)
    setShowAddCustomPrice(true)
  }

  function handleCloseAddCustomPrice() {
    setShowAddCustomPrice(false)
  }

  function closeAddBundlePopover() {
    setPopoverAnchor(null)
    setReactSelectedBundle(null)
  }

  useEffect(() => {
    console.log(selectedBundleIds)
  }, [selectedBundleIds])

  return (
    <>
      <BundlePackHeadingContainer>
        <GenericModalHeadlineLevelTwo>Current Bundles</GenericModalHeadlineLevelTwo>
        <IconButton onClick={addBundle} disabled={isDisabled}>
          <Add />
        </IconButton>
      </BundlePackHeadingContainer>
      <ActualBundlePacksContainer>
        {selectedBundleIds?.length > 0 ? (
          selectedBundleIds?.map((bdlId, idx) => {
            const foundBundle = allBundles?.find((bundle) => bundle?.id === bdlId)
            return (
              <BundlePackItem key={bdlId}>
                <span>{foundBundle?.title}</span>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
                  <IconButton onClick={() => deleteBundle(idx)} disabled={isDisabled}>
                    <Delete />
                  </IconButton>
                  <IconButton onClick={() => editBundle(idx)} disabled={isDisabled}>
                    <Edit />
                  </IconButton>
                </Box>
              </BundlePackItem>
            )
          })
        ) : (
          <span>No bundles selected</span>
        )}
      </ActualBundlePacksContainer>

      <Popover
        open={Boolean(popoverAnchor)}
        anchorEl={popoverAnchor}
        onClose={closeAddBundlePopover}
        anchorOrigin={{
          vertical: 'center',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box sx={{ p: 2, width: '350px' }}>
          <GenericModalHeadlineLevelTwo>Add a bundle</GenericModalHeadlineLevelTwo>
          <Box sx={{ display: 'flex', alignItems: 'center', flexDirection: 'column', gap: '5px' }}>
            <CustomSelect
              id="bundle-select"
              options={allBundles?.filter((item) => {
                console.log({ item, selectedPlanId })
                if (selectedBundleIds?.includes(item?.id)) {
                  return false
                }
                if (!selectedPlanId) {
                  return false
                }
                if (
                  item?.packKind === 'session' &&
                  item?.eligibleSubscriptionPlanId &&
                  item?.eligibleSubscriptionPlanId !== selectedPlanId
                ) {
                  return false
                }
                if (
                  Array.isArray(item?.bundle) &&
                  item?.bundle?.length > 0 &&
                  item?.bundle?.every((bndl) => bndl?.pricingPackId !== selectedPlanId)
                ) {
                  return false
                }
                return true
              })}
              value={reactSelectedBundle}
              placeholder="Select your existing bundles"
              onChangeEvent={(eve) => setReactSelectedBundle(eve.target.value)}
              selectType={selectTypes.object}
              getOptionLabel={(option) => option?.title}
              getOptionValue={(option) => option?.id}
              isDisabled={isDisabled}
            />
            <strong>or</strong>
            <ChangesWillNotBeSavedButton onClick={createBundle} sx={{ width: '100%' }}>
              Create a Bundle
            </ChangesWillNotBeSavedButton>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: 4 }}>
            <ChangesWillNotBeSavedButton
              sx={{ background: '#415dfc' }}
              disabled={!reactSelectedBundle || isDisabled}
              onClick={addBundleToList}
            >
              Add Bundle to this event
            </ChangesWillNotBeSavedButton>
          </Box>
        </Box>
      </Popover>

      <Dialog
        open={showAddCustomPrice}
        onClose={handleCloseAddCustomPrice}
        PaperComponent={MentorEventsPageStyledDialogPaper}
      >
        <BaseAddCustomPriceComponent
          selectedPlan={bundlePackToEdit}
          setSelectedPlan={setBundlePackToEdit}
          handleChangePlan={(eve) => genericHandleChange(eve, setBundlePackToEdit)}
          closeFunction={handleCloseAddCustomPrice}
          allOneOnOnePlans={allOneOnOnes}
          refreshOneOnOnePlans={refreshBundles}
          type="bundle"
          mentorProfileData={mentorProfileData}
          saveBundlePackApi="/api/secure/teacher/1on1-custom-bundle/save"
          preselectedPlanId={selectedPlanId}
          onSaveSuccess={(savedBundle) => {
            if (savedBundle?.id) {
              setSelectedBundleIds((prev) =>
                prev?.includes(savedBundle?.id) ? prev : [savedBundle?.id, ...(prev || [])],
              )
            }
          }}
          isDisabled={isDisabled}
        />
      </Dialog>
      <ConfirmationModal newImplementation {...confirmationProps} />
    </>
  )
}
